import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { StationAuthenticationService } from 'core.services/station-authentication.service';
import { take } from 'rxjs/operators';
import { AnonymousContentPage } from 'shared.components/anonymous-content-page/anonymous-content-page';

@Component({
  selector: '[nc-password-reset]',
  templateUrl: './password-reset.component.html',
  standalone: false,
})
export class PasswordResetComponent extends AnonymousContentPage {

  constructor(
    private router: Router,
    private stationAuthenticationService: StationAuthenticationService,
  ) {
    super();
  }

  logIn(): void {
    this.stationAuthenticationService.redirectToLoginPage().pipe(take(1)).subscribe();
  }

  cancel(): void {
    this.router.navigate(['/login']);
  }
}
